export default __webpack_public_path__ + "static/media/gallery_05.34ad81f3.jpg";